import { useRef } from 'react';
import { useLockBodyScroll, useToggle } from 'react-use';
/**
 * 控制是否锁定元素滚动
 * @param elementToLock 要锁定滚动的元素
 */
export function useScrollLock(elementToLock) {
    if (elementToLock === void 0) { elementToLock = document.body; }
    var _a = useToggle(false), locked = _a[0], toggleLocked = _a[1];
    useLockBodyScroll(locked, useRef(elementToLock));
    return { toggleLocked: toggleLocked };
}
